import React, { useEffect, useState } from "react";
import styles from "../../../styles/scope2/dashboard.module.css";
import { durationObj, monthSort } from "../../../utils/constant";
import LineChart from "../../../Components/GraphNCharts/LineChart";
import DashboardCard from "../../../Components/Common/DashboardCard";
import BarChart from "../../../Components/GraphNCharts/BarChart";
import GlobalChart from "../../../Components/GraphNCharts/GlobalChart";
import TableChart from "../../../Components/GraphNCharts/TableChart";
import EchartDoughnutChart from "../../../Components/GraphNCharts/EchartDoughnut";
import { get } from "../../../utils/api";
import { Box, Typography } from "@mui/material";
import PeriodFilter from "../../../Components/Common/PeriodFilter";
import { fixedTons, formatNumberCommaSeparated } from "../../../utils/common";
import NoDataFound from "../../../Components/Masters/NoDataFound";
import useAuthStore from "../../../store/ContextUser";

const Dashboard = () => {
  const currentDate = new Date();
  const {selectedCompany}= useAuthStore();
  const currentYear = currentDate.getFullYear();
  const [month, setMonth] = useState("1M");
  const [tableData, setTableData] = useState();
  const [energyConsumption, setEnergyConsumption] = useState({});
  const [energyByFacility, setEnergyByFacility] = useState({});
  const [emissionByFacility, setEmissionByFacility] = useState([]);
  const [totalEmission, setTotalEmission] = useState([]);
  const [emission, setEmission] = useState([]);
  const [efficiency, setEfficiency] = useState([]);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [selectedFacility, setSelectedFacility] = useState([]);
  // useEffect(() => {
  //   const currentDate = new Date();
  //   setMonth(String(currentDate.getMonth() + 1).padStart(2, "0"));
  //   setYear(currentDate.getFullYear());
  // }, []);

  useEffect(() => {
    fetchEnergyConsumption();
    fetchEnergyByFacility();
    fetchEmissionByFacility();
    fetchTotalEmission();
    fetchEmission();
    fetchEfficiency();
  }, [fromDate, toDate, selectedFacility,selectedCompany]);

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/scope2/totalEmission?timeFrame=${month}&companyId=${selectedCompany?._id}`
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month,selectedCompany]);

  const generateYearList = (startYear = 2020) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2020);
  const colors = [
    "rgba(255, 68, 68, 1)",
    "rgba(255, 187, 51, 1)",
    "rgba(0, 102, 231, 1)",
  ];

  const fetchEnergyConsumption = async () => {
    const res = await get(
      `/dashboard/scope2/energy-consumption?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );

    console.log(
      res?.data?.data?.some((el) => el?.data?.some((e) => e?.totalConsumption)),
      res?.data?.data,
      "check"
    );
    setEnergyConsumption({
      total: res?.data?.total,
      labels: res?.data?.data?.[0]?.data?.map(
        (el) => monthSort[el?.month - 1] + "'" + el?.year.toString().slice(-2)
      ),
      dataSet: res?.data?.data?.some((el) =>
        el?.data?.some((e) => e?.totalConsumption)
      )
        ? res?.data?.data?.map((el, i) => ({
            label: el?.emission,
            data: el?.data?.map((e) => fixedTons(e?.totalConsumption)),
            borderColor: colors[i],
            backgroundColor: colors[i],
            tension: 0.4,
            fill: true,
            pointRadius: 0,
          }))
        : [],
    });
  };

  const fetchEnergyByFacility = async () => {
    const res = await get(
      `/dashboard/scope2/emission?startYear=${fromDate.year}&startMonth=${
        fromDate.month
      }&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setEnergyByFacility({
      data: [
        parseFloat(res?.data)?.toFixed(3) || 0,
        parseFloat(res?.data)?.toFixed(3) || 0,
      ],
      backgroundColor: ["#FFBB33", "#0066E7"],
      borderColor: "#fff",
      borderWidth: 0,
      offset: [0, 15],
    });
  };

  const fetchEmissionByFacility = async () => {
    const res = await get(
      `/dashboard/scope2/emission-facility?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setEmissionByFacility(res?.data?.data);
  };

  let dataSet = [
    {
      label: "Electricity",
      data: emissionByFacility?.map((el) =>
        parseFloat(el?.electricity)?.toFixed(3)
      ),
      borderColor: "rgba(0, 102, 231, 1)",
      backgroundColor: "#FF4F4F",
      tension: 0.4,
      fill: true,
      pointBorderColor: "#fff",
      pointRadius: 0,
    },
    {
      label: "Steam",
      data: emissionByFacility?.map((el) => parseFloat(el?.steam)?.toFixed(3)),
      borderColor: "rgba(0, 102, 231, 1)",
      backgroundColor: "#0E62E0",
      tension: 0.3,
      fill: true,
      pointRadius: 0,
    },
    {
      label: "Heat",
      data: emissionByFacility?.map((el) => parseFloat(el?.heat)?.toFixed(3)),

      borderColor: "rgba(0, 102, 231, 1)",
      backgroundColor: "#FFBB33",
      tension: 0.3,
      fill: true,
      pointRadius: 0,
    },
  ];

  const fetchTotalEmission = async () => {
    const res = await get(
      `/dashboard/scope2/emission?startYear=${fromDate.year}&startMonth=${
        fromDate.month
      }&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setTotalEmission(res?.data);
  };

  const fetchEfficiency = async () => {
    const res = await get(
      `/dashboard/scope2/efficiency?startYear=${fromDate.year}&startMonth=${
        fromDate.month
      }&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setEfficiency();
  };

  const fetchEmission = async () => {
    const res = await get(
      `/dashboard/scope2/emission/comparison-facility?startYear=${
        fromDate.year
      }&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${
        toDate.month
      }&facilities=${selectedFacility.join(",")}&companyId=${selectedCompany?._id}`
    );
    setEmission(
      res?.data?.data?.map((item) => ({
        title: item?.emission + " : ",
        labels: res?.data?.data?.[0]?.data?.[0]?.data?.map(
          (el) =>
            monthSort[el?.month - 1] + "'" + el?.year?.toString().slice(-2)
        ),
        dataSet: item?.data?.some((el) => el?.data?.some((e) => e))
          ? item?.data?.map((el, i) => ({
              label: el?._id,
              data: el?.data?.map((item) => fixedTons(item?.totalEmission)),
              borderColor: colors[i],
              backgroundColor: colors[i],
              tension: 0.4,
              fill: true,
              pointRadius: 0,
            }))
          : [],
      }))
    );
  };

  return (
    <div>
      <div className={styles.heading_container}>
        <p className={styles.heading}>Scope 2</p>
        <PeriodFilter
          {...{
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            yearList,
            setSelectedFacility,
            selectedFacility,
          }}
        />
      </div>

      <p className={styles.card_heading}>Energy Consumption Analysis</p>
      <div className={styles.cards_container_main}>
        <div className={styles.cards}>
          <p className={styles.emission_heading}>
            Total Energy Consumption (KWH) :{" "}
            <span className={styles.emission_heading_span}>
              {formatNumberCommaSeparated(fixedTons(energyConsumption?.total))}
            </span>
          </p>
          {/* <div className={styles.scopeSection}>
            {dataSet?.map((item, index) => (
              <div key={index} className={styles.scopeItem}>
                <div className={styles.scopeContent}>
                  <p
                    className={styles.scopeIcon}
                    style={{ backgroundColor: colors[index] }}
                  ></p>
                  <p className={styles.scopeHeading}>{item.label}</p>
                </div>
              </div>
            ))}
          </div> */}

          <LineChart
            dataset={energyConsumption?.dataSet}
            labels={energyConsumption?.labels}
            yAxisTitle={"Energy Unit (in KWH)"}
            customHeight={300}
            display={true}
          />
        </div>

        {/* <div className={styles.diversity_container}>
          <p className={styles.emission_heading}>
            Energy Consumption by Facility
          </p>
          <div className={styles.diversity_pie_chart}>
            <PieChart
              labels={["Company Owned", "Third Party Vehicles"]}
              dataset={customDatasets}
              customWidth={150}
              customHeight={150}
            />
            <div className={styles.table_div}>
              {labels.map((item, index) => (
                <div key={index} className={styles.table_container}>
                  <div className={styles.table_row}>
                    <span
                      className={styles.table_row_label}
                      style={{
                        backgroundColor: item.color,
                      }}
                    ></span>
                    <div className={styles.table_text_container}>
                      <span className={styles.table_text}>{item.label}</span>
                      <br />
                      <span className={styles.table_text}>{item.value}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
      </div>

      <p className={styles.card_heading}>Emission Analysis</p>
      <div className={styles.cards_container_one}>
        <div className={styles.cards}>
          <p className={styles.emission_heading}>Emissions by Facility</p>
          {/* <div className={styles.scopeSection}>
            {dataSet?.map((item, index) => (
              <div key={index} className={styles.scopeItem}>
                <div className={styles.scopeContent}>
                  <p
                    className={styles.scopeIcon}
                    style={{ backgroundColor: item.backgroundColor }}
                  ></p>
                  <p className={styles.scopeHeading}>{item.label}</p>
                </div>
              </div>
            ))}
          </div> */}

          <BarChart
            datasets={dataSet}
            labels={emissionByFacility?.map((el) => el?.facilityName)}
            customWidth={"100%"}
            customHeight={350}
            yAxisTitle={"Emissions (tCO2e)"}
          />
        </div>
        <div className={styles.cards}>
          <p className={styles.emission_heading}>
            Total Scope 2 Emissions (tCO2e) :{" "}
            <span className={styles.emission_heading_span}>
              {formatNumberCommaSeparated(fixedTons(totalEmission?.total ?? 0))}
            </span>
          </p>
          {totalEmission?.data?.map((el) => el?.total)?.filter(Boolean)
            ?.length > 0 ? (
            <div className={styles.stationary_chart_container}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  m: "auto",
                  mt: 4,
                }}
              >
                <EchartDoughnutChart
                  labels={totalEmission?.data?.map((el) => el?.emission)}
                  dataPoints={totalEmission?.data?.map((el) =>
                    fixedTons(el?.total)
                  )}
                  colors={dataSet?.map((el) => el?.backgroundColor)}
                  legendPosition="top"
                  customWidth={180}
                  customHeight={200}
                />
              </Box>

              <Box sx={{ width: "100%" }}>
                <div className={styles.doughnut_table_div}>
                  {totalEmission?.data?.map((item, index) => (
                    <div key={index} className={styles.table_container}>
                      <div className={styles.table_row}>
                        <span
                          className={styles.table_row_label}
                          style={{
                            backgroundColor: dataSet[index].backgroundColor,
                          }}
                        ></span>
                        <span className={styles.table_text}>
                          {item?.emission}
                        </span>
                      </div>
                      <span className={styles.table_text}>
                        {formatNumberCommaSeparated(
                          fixedTons(item?.total ?? 0)
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              </Box>
            </div>
          ) : (
            <NoDataFound mt={"30%"} />
          )}
        </div>
      </div>

      <p className={styles.card_heading}>Energy Efficiency Analysis</p>
      <div className={styles.energy_cards_container}>
        <DashboardCard
          title={"Energy consumed per unit of production"}
          subHeading={""}
          value={"75%"}
          changeValue={"+15% YOY"}
          change={"increase"}
        />
        <DashboardCard
          title={"Energy consumed per square of production"}
          subHeading={""}
          value={"75%"}
          changeValue={"+15% YOY"}
          change={"increase"}
        />
        <DashboardCard
          title={"Improvement Over Time"}
          subHeading={""}
          value={"75%"}
          changeValue={"+15% YOY"}
          change={"increase"}
        />
      </div>

      <p className={styles.card_heading}>Geographical analysis</p>
      <div className={styles.world_map_container}>
        <div className={styles.world_map_heading_container}>
          <p className={styles.emission_heading}>
            Energy Consumption by Country
          </p>
          <div style={{ display: "flex", gap: "12px" }}>
            <select
              name="month"
              id="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              className={styles.heading_select_month}
            >
              {durationObj?.map((m) => (
                <option key={m?.id} value={m?.id}>
                  {m?.label}
                </option>
              ))}
            </select>

            {/* <select
              name="year"
              id="year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className={styles.heading_select_year}
            >
              {["World"].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select> */}
          </div>
        </div>
        <div className={styles.world_map_data}>
          <div className={styles.world_map_table}>
            <TableChart tableData={tableData} />
          </div>
          <div className={styles.world_map_chart}>
            <GlobalChart tableData={tableData} />
          </div>
        </div>
      </div>

      <p className={styles.card_heading}>
        Comparative and Benchmarking Analysis
      </p>
      <Box
        sx={{ display: "flex", flexDirection: "column", gap: "1.2rem", mb: 2 }}
      >
        {emission?.map((el, idx) => (
          <div key={idx} className={styles.comparative_container}>
            <div className={styles.cards}>
              <p className={styles.emission_heading}>
                {el?.title}
                <span className={styles.emission_heading_span}>
                  Top 3 facilities
                </span>
              </p>
              {/* <div className={styles.scopeSection}>
                {el?.dataSet?.map((item, index) => (
                  <div key={index} className={styles.scopeItem}>
                    <div className={styles.scopeContent}>
                      <p
                        className={styles.scopeIcon}
                        style={{ backgroundColor: colors[index] }}
                      ></p>
                      <p className={styles.scopeHeading}>{item.label}</p>
                    </div>
                  </div>
                ))}
              </div> */}
              <LineChart
                dataset={el?.dataSet}
                labels={el?.labels}
                yAxisTitle={"Emissions (tCO2e)"}
                customWidth="100%" // Optional custom width
                // customHeight="350px" // Optional custom height
                display={true}
              />
            </div>
          </div>
        ))}
      </Box>
    </div>
  );
};

export default Dashboard;
